// 模板 6：教育培训与在线学习平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '一站式在线学习平台',
        content:
          '支持直播课堂、录播课程与练习测评，满足多种教学场景。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '学习数据可视化',
        content:
          '从课前预习到课后复习，完整记录学习行为，为教学提供数据支撑。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '教学过程数字化',
      subtitle: '/ Digital Teaching Process',
      paragraphs: [
        '平台为机构提供从招生、教学到服务的一体化工具，帮助教务与教师协同管理教学过程。',
        '学习数据实时汇总，帮助老师了解学生掌握情况，调整教学节奏。'
      ],
      buttonText: '预约产品演示'
    },
    contact: {
      title: '教育机构的数字化助手',
      subTitle: '让教学更高效，让学习更有趣',
      buttonText: '获取解决方案'
    },
    customers: [
      {
        logo: require('@/assets/img/logo_hp.png'),
        title: 'K12 教培机构 · 校长',
        content:
          '系统大幅提升了我们教务管理与排课效率，家长也可以随时了解孩子的学习进度。'
      }
    ],
    advantages: [
      {
        icon: require('@/assets/img/qiniu.png'),
        title: '支持多种教学形式',
        html: '<p>直播、录播与双师课堂</p>灵活适配不同教学模式'
      },
      {
        icon: require('@/assets/img/tel.png'),
        title: '家校沟通更顺畅',
        html: '<p>消息通知与作业反馈</p>让家长参与到孩子成长中'
      }
    ]
  },
  company: {
    name: '云课教育科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注为教育培训机构提供 SaaS 平台与定制化解决方案，覆盖 K12、职业教育与企业培训等多个方向。',
      '我们相信技术可以让优质教育资源触达更多人群，用数据和工具帮助老师专注于教学本身。'
    ]
  },
  news: [
    {
      id: 'E01',
      title: '职业教育在线课堂平台成功上线',
      introduce:
        '平台支持多端接入与互动教学工具，帮助合作机构顺利完成线下课程的线上化转型。',
      date: '01-15',
      year: '2025'
    },
    {
      id: 'E02',
      title: '推出学习行为分析模块',
      introduce:
        '基于学习时长、完成度与互动情况，生成学习画像，辅助教学教研决策。',
      date: '09-26',
      year: '2024'
    },
    {
      id: 'E03',
      title: '与多家出版社展开内容合作',
      introduce:
        '双方将围绕数字教材与习题资源展开合作，提供更丰富的教学内容选择。',
      date: '06-08',
      year: '2024'
    },
    {
      id: 'E04',
      title: '家校互动小程序新增多项功能',
      introduce:
        '新增学习日报、作业提醒与线上家长会等功能，进一步提升家校沟通效率。',
      date: '11-30',
      year: '2023'
    },
    {
      id: 'E05',
      title: '入选教育信息化优秀解决方案目录',
      introduce:
        '公司在线教学平台方案入选某地区教育信息化优秀解决方案目录。',
      date: '04-02',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '教务与排课管理系统',
      sections: [
        {
          heading: '1. 招生与报名管理',
          content:
            '从意向线索到正式报名，系统全流程记录，方便市场与教务协同跟进。'
        },
        {
          heading: '2. 智能排课',
          content:
            '根据教室与老师时间自动生成排课方案，避免冲突并提高资源利用率。'
        },
        {
          heading: '3. 上课与考勤记录',
          content:
            '一键记录上课与考勤情况，支持家长端实时查看出勤信息。'
        },
        {
          heading: '4. 费用与续费提醒',
          content:
            '对即将到期课程与欠费情况进行提醒，帮助机构稳步提升续费率。'
        }
      ]
    },
    bigData: {
      title: '学习数据分析平台',
      sections: [
        {
          heading: '1. 班级学习情况对比',
          desc:
            '按班级与教师维度对比学习数据，辅助教学质量评估与课程优化。'
        },
        {
          heading: '2. 学生个体追踪',
          desc:
            '为每个学生生成学习轨迹，方便老师与家长及时发现问题并跟进。'
        },
        {
          heading: '3. 课程热度分析',
          desc:
            '从报名与完课率两个维度衡量课程受欢迎程度，为课程迭代提供参考。'
        },
        {
          heading: '4. 机构运营看板',
          desc:
            '集中展示招生、续费与退费等关键指标，帮助管理者掌握机构经营状况。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '教育数字化咨询',
      engTitle: 'Edu Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '在线教学平台搭建',
      engTitle: 'Online Learning Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '运营与教研支持',
      engTitle: 'Ops & Teaching Support',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '品牌课程共建',
      engTitle: 'Course Co-Creation',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '教育产品运营专员',
    responsibilities: [
      '负责在线学习产品的日常运营与活动策划；',
      '跟进合作机构需求，协助落地教学与运营方案；',
      '整理用户反馈，推动产品功能持续优化。'
    ],
    requirements: [
      '热爱教育行业，有教培机构或在线教育平台运营经验者优先；',
      '具备良好的沟通能力与执行力，能够独立推进项目；',
      '对数据敏感，善于通过数据分析发现问题与机会。'
    ],
    buttonText: '立即申请'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-6.js